// Inline styles for the component
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#e9ecef',
        fontFamily: 'Arial, sans-serif',
        padding: '10px',
        overflow: 'auto',
    },
    card: {
        background: 'linear-gradient(135deg, #f8f4ff 0%, #e0e4f7 100%)',
        borderRadius: '2px',
        borderBottom: '5px solid dodgerblue',
        borderRight: '5px solid dodgerblue',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
        padding: '25px',
        width: '100%',
        maxWidth: '550px',
        position: 'relative',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        cursor: 'pointer',
        margin: '20px',
    },
    title: {
        textAlign: 'left',
        color: 'transparent',
        marginBottom: '15px',
        fontSize: '24px',
        fontWeight: '700',
        background: 'linear-gradient(90deg, #007bff, #00c851)',
        WebkitBackgroundClip: 'text',
        backgroundClip: 'text',
        letterSpacing: '1px',
        paddingBottom: '5px',
        position: 'relative',
        display: 'inline-block',
    },
    icon: {
        marginRight: '5px',
        verticalAlign: 'middle',
    },
    formGroup: {
        marginBottom: '15px',
        display: 'flex',
        flexDirection: 'column',
    },
    label: {
        marginBottom: '3px',
        fontWeight: 'bold',
        color: '#495057',
    },
    inputContainer: {
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #ced4da',
        borderRadius: '5px',
        overflow: 'hidden',
    },
    iconContainer: {
        padding: '10px',
        backgroundColor: '#007bff',
        color: 'white',
    },
    input: {
        padding: '10px',
        border: 'none',
        borderRadius: '0 5px 5px 0',
        width: '100%',
        fontSize: '14px',
        transition: 'border-color 0.3s',
    },
    textarea: {
        padding: '10px',
        border: '1px solid #ced4da',
        borderRadius: '5px',
        width: '100%',
        fontSize: '14px',
        resize: 'vertical',
        minHeight: '80px',
        transition: 'border-color 0.3s',
    },
    button: {
        padding: '10px',
        border: 'none',
        borderRadius: '5px',
        backgroundColor: '#007bff',
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bolder',
        cursor: 'pointer',
        width: '100%',
        transition: 'background-color 0.3s, transform 0.1s',
        marginTop: '10px',
    },

    // Add hover and active states
    buttonHover: {
        backgroundColor: '#0056b3',
    },

    buttonActive: {
        transform: 'scale(0.95)',
    },
    loginLink: {
        marginTop: '15px',
        textAlign: 'center',
        fontSize: '12px',
    },
    loginText: {
        color: '#333',
        marginRight: '5px',
        fontSize: '14px',
    },
    loginLinkText: {
        color: '#007bff',
        textDecoration: 'none',
        transition: 'color 0.3s ease',
        fontSize: '14px',
    },
    infoIcon: {
        cursor: 'pointer',
        fontSize: '20px',
        color: 'yellow',
        marginLeft: '10px',
    },
    tooltip: {
        display: 'none',
        position: 'absolute',
        top: '10%',
        right: '10%',
        width: '300px',
        fontSize: '14px',
        backgroundColor: '#ffffff',
        border: '1px solid #007bff',
        borderRadius: '8px',
        padding: '10px',
        boxShadow: '0 6px 12px rgba(0, 0, 0, 0.2)',
        zIndex: '1',
        color: '#495057',
        transition: 'opacity 0.3s ease, transform 0.3s ease',
        opacity: 0,
        transform: 'translateY(-5px)',
    },
    tooltipVisible: {
        display: 'block',
        opacity: 1,
        transform: 'translateY(0)',
    },
    tooltipList: {
        listStyleType: 'none',
        paddingLeft: '0',
        margin: '0',
    },
    tooltipListItem: {
        position: 'relative',
        paddingLeft: '15px',
        marginBottom: '5px',
    },
    bulletPoint: {
        position: 'absolute',
        left: '0',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        backgroundColor: '#007bff',
    },
    // Media Queries for Responsiveness
    '@media (min-width: 1200px)': { // Desktops
        container: {
            height: '100vh',
            padding: '20px 50px',
        },
        card: {
            width: '70%',
            margin: '0 auto',
            padding: '40px',
        },
        title: {
            fontSize: '32px',
        },
        button: {
            fontSize: '16px',
            padding: '12px 24px',
        },
        loginText: {
            fontSize: '16px',
        },
        loginLinkText: {
            fontSize: '16px',
        },
    },
    '@media (min-width: 1024px) and (max-width: 1199px)': { // Laptops
        container: {
            height: '90vh',
            padding: '15px 40px',
        },
        card: {
            width: '80%',
            margin: '0 auto',
            padding: '30px',
        },
        title: {
            fontSize: '28px',
        },
        button: {
            fontSize: '14px',
            padding: '10px 20px',
        },
        loginText: {
            fontSize: '14px',
        },
        loginLinkText: {
            fontSize: '14px',
        },
    },
    '@media (max-width: 768px)': { // Tablets and below
        card: {
            padding: '15px',
            margin: '10px',
        },
        title: {
            fontSize: '20px',
        },
        button: {
            fontSize: '12px',
            padding: '8px',
        },
        loginText: {
            fontSize: '12px',
        },
        loginLinkText: {
            fontSize: '12px',
        },
    },
    '@media (max-width: 480px)': { // Mobile devices
        container: {
            height: 'auto',
            padding: '5px',
        },
        card: {
            width: '100%',
            padding: '20px',
        },
        title: {
            fontSize: '18px',
        },
        button: {
            fontSize: '12px',
            padding: '8px',
        },
        loginText: {
            fontSize: '12px',
        },
        loginLinkText: {
            fontSize: '12px',
        },
    },
};

export default styles;